<template lang="pug">
div
  v-layout(justify-space-between, align-center)
    v-layout.flex-column-phone(align-center)
      img(src='/images/maex-logo.jpg', height='50')
      h3 MAEX
      span.grey--text.ml-2 (Fitsolutions)

    pricing-dialog(
      title='Maex / Fitsolutions',
      :header='["Soort", "Kosten"]'
      :items='[{ name: "Exporteren naar Maex", value: "Gratis" }, { name: "Gebruik interne FTP", value: "€ 2,50 excl. BTW per maand" }]'
      )

  v-divider.mt-4.mb-4

  h3 MaexInfo
  p Laat leeg indien er geen onderliggende tussenpersonen gekoppeld dient te worden (alleen voor serviceproviders).

  v-layout(wrap, style='margin-right: -30px')
    text-field.small(
      label='produkt_id',
      v-model='data.maexInfo.produkt_id'
      )

    text-field.small(
      label='status_id',
      v-model='data.maexInfo.status_id'
      )

    text-field.small(
      label='tp_id',
      v-model='data.maexInfo.tp_id'
      )

    text-field.small(
      label='bron_id',
      v-model='data.maexInfo.bron_id'
      )

    text-field.small(
      label='gebruiker_id',
      v-model='data.maexInfo.gebruiker_id'
      )

    text-field.small(
      label='subagent_id',
      v-model='data.maexInfo.subagent_id'
      )

    text-field.small(
      style='margin-right: 30px',
      label='verkoper_id',
      v-model='data.maexInfo.verkoper_id'
      )

  v-divider.mt-2.mb-4

  h3 Exporteren naar
  p Maex maakt gebruik van een maex_import via FTP om de aanvragen in te lezen. Maak de keuze of je een eigen FTP-account hebt of gebruik wil maken van onze FTP-account.
  p Let op! Aan de interne FTP-account zitten extra kosten verbonden.

  v-radio-group(v-model='data.customFtpServer')
    v-layout.flex-column-phone
      v-radio.mb-0(:value='false', label='Interne FTP', color='primary')
      v-radio.mb-0(:value='true', label='Externe FTP', color='primary')

  div
    p(v-if='data.customFtpServer') Vul de gegevens van je FTP server in.
    p(v-else) Vul de onderstaande gegevens in Maex in om de aanvragen op te halen.

    text-field.mr-0(
      label='Hostnaam',
      v-model='data.host',
      :readonly='!data.customFtpServer',
      placeholder='Bijv: ftp://mijnwebsite.nl of ftp://192.168.1.1'
      )

    v-layout.flex-column-phone
      text-field(
        label='Gebruikersnaam',
        v-model='data.username',
        :readonly='!data.customFtpServer'
        )

      text-field(
        label='Wachtwoord',
        v-model='data.password',
        type='password',
        :append-icon="passwordVisible || !data.customFtpServer ? 'fa fa-eye-slash' : 'fa fa-eye'"
        @click:append='passwordVisible = !passwordVisible',
        :type="passwordVisible || !data.customFtpServer ? 'text' : 'password'",
        :readonly='!data.customFtpServer'
        )
</template>

<script>
import slug from 'slug'
import randomatic from 'randomatic'
import { required } from 'vuelidate/lib/validators'
import { exportMethodsEnum } from '@/helpers/constants'

const DFS_MAEX_FTP_HOST = 'ftp://maex-test.dealerfinanceservices.nl'

export default {
  props: {
    value: Object
  },

  components: {
    PricingDialog: require('@/components/PricingDialog').default
  },

  data () {
    return {
      data: Object.assign({
        maexInfo: {},
        customFtpServer: false
      }, this.value),
      passwordVisible: false,

      generatedUsername: null,
      generatedPassword: null
    }
  },

  computed: {
    hostValidationErrors () {
      const errors = []
      if (!this.$v.data.host.$dirty) return errors
      !this.$v.data.host.required && errors.push('Dit veld is verplicht')
      return errors
    },

    usernameValidationErrors () {
      const errors = []
      if (!this.$v.data.username.$dirty) return errors
      !this.$v.data.username.required && errors.push('Dit veld is verplicht')
      return errors
    },

    passwordValidationErrors () {
      const errors = []
      if (!this.$v.data.password.$dirty) return errors
      !this.$v.data.password.required && errors.push('Dit veld is verplicht')
      return errors
    }
  },

  methods: {
    init () {
      const maexExport = this.$store.state.organization.current.exportMethods.find(x => x.method === exportMethodsEnum.MaexFtp.method)

      if (maexExport) {
        this.data.username = maexExport.username
        this.data.password = maexExport.password
        this.data.host = maexExport.host
      } else {
        this.$set(this.data, 'username', this.generatedUsername)
        this.$set(this.data, 'password', this.generatedPassword)
        this.$set(this.data, 'host', DFS_MAEX_FTP_HOST)
      }
    }
  },

  watch: {
    data: {
      handler: function (v) {
        this.$emit('input', v)
      },
      deep: true
    },

    '$v.$invalid': {
      handler: function (v) {
        this.$emit('valid', !v)
      },
      immediate: true
    },

    'data.customFtpServer': function (v) {
      if (v) {
        this.data.username = null
        this.data.password = null
        this.data.host = null
      } else {
        // this.init()
        this.data.username = this.generatedUsername
        this.data.password = this.generatedPassword
        this.data.host = DFS_MAEX_FTP_HOST
      }
    }
  },

  created () {
    // TODO generatedUsername must be unique because if it conflicts it will override password and all leases from the other org will be uploaded to this one... OOPS pretty bad right

    this.generatedUsername = slug(this.$store.state.organization.current.dataGeneral.companyName).toLowerCase() // TODO this doesnt work if dataGeneral isnt filled in yet, needs to be done first
    this.generatedPassword = randomatic('Aa0', 16)

    this.init()
  },

  validations: {
    data: {
      host: {
        required
      },

      username: {
        required
      },

      password: {
        required
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
